//banner paypal in PDP

document.addEventListener('variant:change', function(evt) {
    var amount = evt.detail.variant.price;
    var element = document.querySelectorAll('[data-pp-amount]');
    if (!element) {
        return;
    }
    var amount = amount / 100;
    element.forEach(function(el) {
        el.setAttribute('data-pp-amount', amount);
    });
});